const initScenarioTabs = () => {
    document.querySelectorAll('.ScenarioTabs > div.wp-block-group').forEach((root) => {
        const tabs = Array.from(root.querySelectorAll<HTMLElement>(':scope > p'));
        const panels = Array.from(root.querySelectorAll<HTMLElement>(':scope > div.wp-block-group'));

        // If markup doesn't match "N tabs, N panels", do nothing safely
        if (!tabs.length || tabs.length !== panels.length) return;

        // Add basic a11y-ish attributes while keeping <p>
        root.setAttribute('role', 'tablist');
        tabs.forEach((tab, i) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');
            tab.setAttribute('aria-selected', tab.classList.contains('is-active') ? 'true' : 'false');

            panels[i].setAttribute('role', 'tabpanel');
            panels[i].hidden = !panels[i].classList.contains('is-active');
        });

        const activate = (index) => {
            tabs.forEach((t, i) => {
                const isActive = i === index;
                t.classList.toggle('is-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                t.setAttribute('tabindex', isActive ? '0' : '-1');

                panels[i].classList.toggle('is-active', isActive);
                panels[i].hidden = !isActive;
            });
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activate(index));
            tab.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    activate(index);
                }
            });
        });

        // Ensure exactly one active on load (default to first)
        const initial = Math.max(0, tabs.findIndex((t) => t.classList.contains('is-active')));
        activate(initial);
    });
}

export default initScenarioTabs